import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ExpirationDateReportsPage = lazy(
  () =>
    import("../../../../components/WMS/Warehouses/ExpirationDateReportsPage"),
)

export const Route = createFileRoute(
  "/_layout/WMS/warehouses/expiration-date-reports",
)({
  component: ExpirationDateReportsRoute,
})

function ExpirationDateReportsRoute() {
  return (
    <LazyRoutePage>
      <ExpirationDateReportsPage />
    </LazyRoutePage>
  )
}
